import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'NumericComparator';
const ENDPOINT = `/numeric-comparators/`;

@Injectable({
    providedIn: 'root'
})
export class NumericComparatorService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
